import Vue from 'vue'
import Router from 'vue-router'
import State from './services/state'
import Auth from './services/auth'
import { ROUTE, USER } from './services/constants'
import SmsComp from './components/sms/SmsComp'
import Register from './components/register/Register'
import Registrations from './components/registrations/Registrations'
import RegistrationSids from './components/registrations/RegistrationSids'
import Login from './components/main/Login'
import ExamComp from './components/exam/ExamComp'
import Courses from './components/course/Courses'
import Exams from './components/exam/Exams'
import Questions from './components/question/Questions'
import Reports from './components/reports/Reports'
import EnrollReports from './components/reports/EnrollReports'

import AnnouncementsPage from './components/pages/AnnouncementsPage'
import RequirementsPage from './components/pages/RequirementsPage'
import ScholarshipsPage from './components/pages/ScholarshipsPage'
import HealthPage from './components/pages/HealthPage'

import Users from './components/user/Users'

Vue.use(Router);

let router = new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [
		{ 
			path: '/', 
			name: ROUTE.HOME, 
			component: AnnouncementsPage 
		},
		{
			path: '/login/:username?',
			name: ROUTE.LOGIN,
			component: Login,
			beforeEnter: (to, from, next) => {
				if(Auth.isLoggedIn()) {
					router.push({ name: 'home' });
				} else {
					next();
				}
			}
		},
		{ 
			path: '/sms', 
			name: ROUTE.SMS, 
			component: SmsComp,
			meta: {
				requires: [ USER.ADMIN, USER.TEACHER, USER.REGISTRAR, USER.TRAINING ]
			} 
		},
		{ 
			path: '/register', 
			name: ROUTE.REGISTER, 
			component: Register 
		},
		{
			path: '/sids',
			name: ROUTE.SIDS,
			component: RegistrationSids,	
			meta: {
				requires: [ USER.ADMIN, USER.REGISTRAR, USER.IT ]
			} 
		},
		{
			path: '/registrations',
			name: ROUTE.REGISTRATIONS,
			component: Registrations,	
			meta: {
				requires: [ USER.ADMIN, USER.REGISTRAR ]
			} 
		},
		{
			path: '/report/registrations',
			name: ROUTE.REGISTRATIONS,
			component: Registrations,	
			meta: {
				requires: [ 
					USER.ADMIN, 
					USER.TEACHER,
					USER.REGISTRAR, 
					USER.TRAINING,
				]
			}
		},
		{
			path: '/exam/:hashId',
			name: ROUTE.EXAM,
			component: ExamComp,	
		},
		{
			path: '/courses',
			name: ROUTE.COURSES,
			component: Courses,	
			meta: {
				requires: [ USER.ADMIN, USER.REGISTRAR, USER.TRAINING ]
			} 
		},
		{
			path: '/exams',
			name: ROUTE.EXAMS,
			component: Exams,		
			meta: {
				requires: [ USER.ADMIN, USER.REGISTRAR ]
			} 
		},
		{
			path: '/questions',
			name: ROUTE.QUESTIONS,
			component: Questions,		
			meta: {
				requires: [ USER.ADMIN, USER.REGISTRAR ]
			} 
		},
		{
			path: '/users',
			name: ROUTE.USERS,
			component: Users,
			meta: {
				requires: [ USER.ADMIN ]
			}
		},
		
		{
			path: '/requirements',
			name: ROUTE.REQUIREMENTS,
			component: RequirementsPage,
		},
		{
			path: '/announcements',
			name: ROUTE.ANNOUNCEMENTS,
			component: AnnouncementsPage,
		},
		{
			path: '/bsrs',
			name: ROUTE.BSRS,
			beforeEnter() {location.href = 'https://bsrs.tesda.gov.ph'},
		},
		{
			path: '/scholarships',
			name: ROUTE.SCHOLARSHIPS,
			component: ScholarshipsPage,
		},	
		{
			path: '/health-protocol',
			name: ROUTE.HEALTH,
			component: HealthPage,
		},
		{
			path: '/reports',
			name: 'reports',
			component: Reports,
			children: [
				// {
				// 	path: 'registrations',
				// 	name: ROUTE.REGISTRATION_REPORT,
				// 	component: RegistrationReports,
				// 	props: { reportMode: true },
				// },
				{
					path: 'enrollees',
					name: ROUTE.ENROLLEE_REPORT,
					component: EnrollReports,
					props: { reportMode: true },
				},
			],
		},
		// {
		//     path: '/search/:searchText?',
		//     name: 'search',
		//     component: CourseList,
		//     props: { mode: 'search' },
		// },
		// {
		//     path: '/qualifications',
		//     name: 'qualifications',
		//     component: Qualifications,
		//     meta: {
		//         requires: [ USER.ADMIN, USER.REGISTRAR ]
		//     } 
		// },
		// {
		//     path: '/category',
		//     name: 'category',
		//     component: Course,
		//     children: [
		//         {
		//             name: 'categoryView',
		//             path: ':categoryId',
		//             component: CourseList,
		//         }
		//     ] 
		// },
		// {
		//     path: '/course',
		//     name: 'course',
		//     component: Course,
		//     children: [
		//         {
		//             path: 'manage',
		//             name: 'courseManagement',
		//             component: CourseList,
		//             props: { mode: 'manage' },
		//             meta: {
		//                 requires: [ USER.ADMIN, USER.REGISTRAR ]
		//             }
		//         },
		//         {
		//             path: ':hashId',
		//             name: 'courseView',
		//             component: CourseView,
		//         },
		//         {
		//             path: 'create/:categoryId?',   
		//             name: 'courseCreate',          
		//             component: CourseForm,
		//             meta: {
		//                 mode: 'create',
		//                 requires: [ USER.ADMIN, USER.REGISTRAR ]
		//             }
		//         },
		//         {
		//             path: ':hashId/update',
		//             name: 'courseUpdate',
		//             component: CourseForm,
		//             meta: {
		//                 mode: 'update',
		//                 requires: [ USER.ADMIN, USER.REGISTRAR ]   
		//             }
		//         }
		//     ] 
		// },
		// {
		//     path: '/quiz',
		//     name: 'quiz',
		//     component: Quizzes,
		//     children: [
		//         {
		//             path: 'manage',
		//             name: 'quizManagement',
		//             component: QuizManager,
		//                 meta: {
		//                     requires: [ USER.ADMIN, USER.REGISTRAR ]
		//                 }
		//         },
		//         {
		//             path: ':hashId',
		//             name: 'quizView',
		//             component: QuizView,
		//         },
		//     ] 
		// },
		// {
		//     path: '/topic',
		//     name: 'topic',
		//     component: Topic,
		//     children: [
		//         {
		//             path: 'manage',
		//             name: 'topicManagement',
		//             component: TopicManager,
		//                 meta: {
		//                     requires: [ USER.ADMIN, USER.REGISTRAR ]
		//                 }
		//         },
		//         // {
		//         //     path: ':hashId',
		//         //     name: 'quizView',
		//         //     component: QuizView,
		//         // },
		//     ] 
		// },
	]
});
	
router.beforeEach((to, from, next) => {

	try {
		Auth.authenticate().then(() => {
			let meta = to.meta;
			let flag = true;
			if(meta) {
				if(meta.requires) {
					if(Auth.isLoggedIn()) {
						let found = -1;
						found = meta.requires.find((userType) => {
							return Auth.getLoggedUser().type == userType;
						});
						if(found == undefined) {
							flag = false;
						}
					} else {
						flag = false;
					}
				}
			}
		
			if(flag) {
				next();
			} else {
				State.previousRoute = {
					name: to.name,
					params: to.params,
					meta: to.meta
				};
				next({name : 'login'});
			} 
		});       
	} catch(e) {
		console.log(to);
		State.previousRoute = {
			name: to.name,
			params: to.params,
			meta: to.meta
		};
		next({ name: 'login'});
	}

	
});

export default router;